<template>
  <!-- <AddButton v-if="showButton" @click="IsCreate()" :btnname=" $t('btn.plusaddnew')" />
      <EditIcon class="" v-if="!showButton" @click="IsEdit()" /> -->
  <Dialog
    v-model:visible="showDialog"
    :modal="true"
    :header="
      model
        ? $t('ItemCategory.ItemCategorySupplierMapping.EditFormheader')
        : $t('ItemCategory.ItemCategorySupplierMapping.Formheader')
    "
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '40vw' }"
    @after-hide="IsClear"
  >
    <b-form @submit.prevent="IsSubmit">
      <b-row>
        <b-col sm="8">
          <div class="field">
            <!-- {{ disablevalue }} -->
            <CustomDropdown
              :disabled="disablevalue"
              :required-icon="true"
              :label="$t('ItemCategory.ItemCategorySupplierMapping.Supplier')"
              :rules="{ required: true }"
              v-model="insert_data.supplierId"
              :items="items"
              @update:value=""
              id="Supplier"
              name="Supplier"
              :autofocus="true"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="8" class="addcircle_field">
          <div class="field">
            <MultipleSelectDropdown
              :label="
                $t('ItemCategory.ItemCategorySupplierMapping.ItemCategory')
              "
              :rules="{ required: true }"
              name="Item Category"
              id="Item Category"
              :requiredIcon="true"
              v-model="itemCategoryIddata"
              :items="Itemcategoryitems"
              @update:value=""
              @input=""
            />
            <!-- <CustomDropdown :required-icon="true" label="Item Category" :rules="{ required: true }"
                            v-model="insert_data.Itemcategory" :items="Itemcategoryitems" @update:value="" id='Item mapping' -->
            <!-- name="Item mapping" /> -->
            <!-- <span class="float-end blue-txt mt-3" @click="FunctionRights(EntityIds.Category, 'Category')">+ Add
              Category</span> -->
          </div>
          <span
            class="add_circle"
            @click="FunctionRights(EntityIds.Category, 'Category')"
            ><i class="pi pi-plus"></i
          ></span>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <Footer
            @cancel="IsClear()"
            :cancelhide="false"
            :label="label"
            :loading="Saveloader"
          />
        </b-col>
      </b-row>
    </b-form>
  </Dialog>
  <CategoryCreation
    v-if="DialogShow.Category"
    @load="Itemcategoryshow(), (DialogShow.Category = false)"
    @close="DialogShow.Category = false"
    :OperationID="ObjOperationId"
    :EntityId="EntityIds.Category"
  />

  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <AlreadyExist
    :selectedcontent="selectedcontent"
    :visible="alreadyexistpop"
    @ok="alreadyclosetrigger()"
  />
  <Toast />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";

import Footer from "../../../../../../components/FormComponents/Footer.vue";
import axios from "axios";
import service from "../../../../Service/UnitMasService";
import { useRoute } from "vue-router";
import TextField from "../../../../../../components/FormComponents/TextInput.vue";
import common from "../../../../Service/SupplierCategoryMappingService";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import CreateSuccessully from "../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import AlreadyExist from "../../../../../../components/FormComponents/AlreadyExist.vue";
import SupplierMasterservice from "../../../../Service/SupplierMaster";
import ItemCategoryservice from "../../../../Service/CategoryService";
import CustomDropdown from "../../../../../../components/FormComponents/Dropdown.vue";
import MultipleSelectDropdown from "../../../../../../components/FormComponents/MultiSelectDropdown.vue";
import moment from "moment";
import CategoryCreation from "../../../Masters/ItemCategory/CategoryMaster/CategoryCreation.vue";
import MastersService from "../../../../Service/MastersService";
import { checkPermission } from "../../../../Service/AccessControl";
import { useToast } from "primevue/usetoast";

export default defineComponent({
  props: {
    trigger: {
      readonly: false,
      type: Boolean,
      default: ref(false),
    },
    selectedItem: {
      type: Object,
      Default: () => {},
    },
    showButton: {
      type: Boolean,
      Required: true,
    },
    OperationID: {
      type: Object,
      default: {},
    },
  },
  components: {
    MultipleSelectDropdown,
    CustomDropdown,

    Footer,
    axios,
    useRoute,
    TextField,
    CreateSuccessully,
    UpdatedSuccessfully,
    AlreadyExist,
    CategoryCreation,
  },
  setup(props, { emit }) {
    debugger;
    let session: any = localStorage.getItem("UsersData");

    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    const { handleSubmit, errors, resetForm, resetField } = useForm();
    const showDialog = ref(false);
    const model: any = ref(props.selectedItem);
    const successpop = ref(false);
    const updatepop = ref(false);
    const alreadyexistpop = ref(false);
    let Saveloader = ref(false);
    let diffArray1: any = [];
    let items = ref([]);
    let Itemcategoryitems = ref([]);
    const { t } = useI18n();
    const toast = useToast();
    const label = ref(t("btn.save"));
    let Entitydata = ref();
    Entitydata.value = localStorage.getItem("EntityData");
    Entitydata.value = JSON.parse(Entitydata.value);
    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }
    let Rights = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });
    const copyRights = JSON.parse(JSON.stringify(Rights.value));
    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
    });
    const copyObjOperationId = JSON.parse(JSON.stringify(ObjOperationId.value));
    let DialogShow = ref({
      Category: false,
    });
    let EntityIds = ref({
      Category: 106,
    });
    const insert_data = ref({
      CreatedAt: "",
      CreatedBy: 0,
      ModifiedBy: 0,
      ModifiedAt: "",

      createdByName: "string",
      Id: 0,
      supplierId: ref(),
      itemCategoryId: [],
      EntityId: 0,
      EntityOperationId: 0,
    });
    let itemCategoryIddata = ref();
    if (model.value != null) {
      IsEdit();
    } else {
      IsCreate();
    }

    onMounted(() => {
      debugger;
      document.addEventListener("keydown", onKeyUp);
      suppliernameshow(), Itemcategoryshow();
    });
    let isSubmitCalled = false;
    function onKeyUp(event: KeyboardEvent) {
      debugger;

      if (event.altKey && event.key == "s") {
        if (!isSubmitCalled) {
          isSubmitCalled = true;
          IsSubmit();
        }
      } else if (
        (event.altKey && event.key == "c") ||
        (event.key == "Escape" &&
          successpop.value == false &&
          updatepop.value == false)
      ) {
        IsClear();
      } else if (event.altKey && event.key == "n") {
        showDialog.value = true;
      } else if (
        event.key == "Escape" &&
        (successpop.value == true || updatepop.value == true)
      ) {
        closetrigger();
      } else if (event.key == "Escape" && alreadyexistpop.value == true) {
        alreadyclosetrigger();
      }
    }

    //Clear Input Fields
    const copyinsert_data = JSON.parse(JSON.stringify(insert_data.value));
    function IsClear() {
      Object.assign(insert_data.value, copyinsert_data);
      insert_data.value.Id = 0;
      showDialog.value = false;
      //emit("update:trigger", false);
      emit("update:selectedItem", undefined);
      emit("close");
    }

    async function suppliernameshow() {
      debugger;
      try {
        const response = await SupplierMasterservice.gettable();
        items.value = response["result"]
          .filter(
            (i1) =>
              i1.IsActive == true &&
              i1.HospitalId == HospitalId &&
              i1.BranchId == BranchId
          )
          .map((item: any) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });
      } catch (error) {
        console.log(error);
      }
    }

    async function Itemcategoryshow() {
      debugger;
      try {
        const dataresponse = await ItemCategoryservice.getdata();

        console.log(dataresponse);

        Itemcategoryitems.value = dataresponse["result"]
          .filter((i1) => i1.Status == true && i1.HospitalId == HospitalId)
          .map((item: any) => {
            item.name = item.Name;
            item.value = item.Id;
            return item;
          });
      } catch (error) {
        console.log(error);
      }
    }
    // Add New PopUp
    function IsCreate() {
      debugger;
      showDialog.value = true;
      // GetCode();
    }

    //Row Edit
    async function IsEdit() {
      debugger;
      showDialog.value = true;
      emit("loadershow");
      try {
        debugger;
        label.value = "Update";
        insert_data.value.supplierId = model.value.SupplierId;
        debugger;
        itemCategoryIddata.value = model.value.itemCategoryIddata;
        // .split(",")
        // .map((str) => parseInt(str));
        diffArray1 = model.value.itemCategoryIddata;
        // .split(",")
        // .map((str) => parseInt(str));
        console.log(diffArray1);
        // if (insert_data.value.supplierId != ref()) {
        //   loading.value = false

        // }
        emit("loaderhide");
      } catch (error) {
        emit("loaderhide");
        alert(error);
      }
    }
    let disablevalue = ref(false);
    let selectedcontent = ref("Name Already Exist");

    //Save
    const IsSubmit = handleSubmit(async (values) => {
      debugger;
      Saveloader.value = true;
      emit("loadershow");
      insert_data.value.CreatedAt = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ");
      insert_data.value.ModifiedAt = moment().format(
        "YYYY-MM-DDTHH:mm:ss.SSSZ"
      );

      insert_data.value.ModifiedBy = UserId;
      insert_data.value.CreatedBy = UserId;
      insert_data.value.EntityId = Number(Entitydata.value.EntityId);

      let objinsert = Object.assign(insert_data.value);
      console.log(objinsert);
      try {
        // alert(insert_data.value.supplierId)
        let msg = "";
        let data_response;
        for (let index = 0; index < itemCategoryIddata.value.length; index++) {
          insert_data.value.itemCategoryId = itemCategoryIddata.value[index];

          data_response = await common.createdata(objinsert);
        }
        debugger;

        console.log(data_response);
        msg = data_response["ErrorInfo"].ErrorCode;
        emit("loaderhide");
        if (data_response["result"] == "false" && msg == null) {
          Saveloader.value = false;
          alreadyexistpop.value = true;
        } else if (msg == null) {
          let arr1: any = JSON.parse(JSON.stringify(itemCategoryIddata.value));
          debugger;
          let delMap = diffArray1.filter((value) => !arr1.includes(value));
          let data_response1: any;
          if (delMap.length > 0) {
            for (let j = 0; j < delMap.length; j++) {
              insert_data.value.itemCategoryId = delMap[j];
              data_response1 = await common.updatedata(objinsert);
            }
            if (data_response1["result"] == "False" && msg == null) {
              Saveloader.value = false;
              alreadyexistpop.value = true;
            } else if (
              data_response1["result"] != "False" &&
              data_response1["result"] != "True" &&
              msg == null
            ) {
              Saveloader.value = false;
              selectedcontent.value = data_response1["result"];
              alreadyexistpop.value = true;
              Itemcategoryshow();
            } else if (msg == null) {
              Saveloader.value = false;
              updatepop.value = true;
            }
          } else {
            Saveloader.value = false;
            successpop.value = true;
          }
        }
      } catch (error) {
        emit("loaderhide");
        alert(error);
        Saveloader.value = false;
      }
    });

    //Get Code
    // async function GetCode() {
    //   debugger;
    //   let data = {
    //     FormId: 20,
    //     HospitalId: 0,
    //     BranchId: 0,
    //   };
    //   let result: any = await common.getCodeTemplate(data);
    //   console.log(result);

    //   insert_data.value.Code = result;
    // }

    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
      showDialog.value = false;
      emit("load");
      IsClear();
    }

    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
      // insert_data.value.Name = "";
    }

    async function FunctionRights(EntityId, FieldType) {
      debugger;
      Object.assign(Rights.value, copyRights);
      Object.assign(ObjOperationId.value, copyObjOperationId);
      const response = await MastersService.CheckMenuRights(
        EntityId,
        rolesData.RoleId
      );
      console.log(response["result"]);

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          ObjOperationId.value.CreateId = operation.OperationID;
          Rights.value.Create = operation.IsActive;
        } else if (operation.OperationName === "Update") {
          ObjOperationId.value.UpdateId = operation.OperationID;
          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          ObjOperationId.value.ReadId = operation.OperationID;
          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          ObjOperationId.value.DeleteId = operation.OperationID;
          Rights.value.Delete = operation.IsActive;
        }
      }
      let permissionResult: any = checkPermission(Rights, "Add");
      if (permissionResult.hasPermission) {
        DialogShow.value[FieldType] = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }
    return {
      Saveloader,
      Itemcategoryshow,
      ObjOperationId,
      FunctionRights,
      EntityIds,
      DialogShow,
      disablevalue,
      itemCategoryIddata,
      Itemcategoryitems,
      items,
      showModal: ref(false),
      insert_data,
      IsSubmit,
      IsEdit,
      IsClear,
      showDialog,
      IsCreate,
      // GetCode,
      successpop,
      updatepop,
      alreadyexistpop,
      closetrigger,
      alreadyclosetrigger,
      label,
      model,
      selectedcontent,
    };
  },
});
</script>
